import { render } from "./OrderPreview.vue?vue&type=template&id=dc883cae&scoped=true&ts=true"
import script from "./OrderPreview.vue?vue&type=script&lang=ts"
export * from "./OrderPreview.vue?vue&type=script&lang=ts"

import "./OrderPreview.vue?vue&type=style&index=0&id=dc883cae&scoped=true&lang=scss"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc883cae"]])

export default __exports__